import firebase from 'firebase/app';
import 'firebase/database';

const config = {
  apiKey: 'AIzaSyCJN-kIgtYSDGPqT47Cp_zWBkIeGhCK3oc',
  authDomain: 'prickpredictor.firebaseapp.com',
  databaseURL: 'https://prickpredictor.firebaseio.com',
  projectId: 'prickpredictor',
  storageBucket: 'prickpredictor.appspot.com',
  messagingSenderId: '638117798055',
};

firebase.initializeApp(config);

const endpointBase = '/flamelink/environments/production';
const locale = 'en-US';

export const endpoints = {
  BLOG: `${endpointBase}/content/blog/${locale}/`,
  MEDIA: `/flamelink/media/files/`,
  QUESTIONS: `${endpointBase}/content/questions/${locale}/`,
  QUESTIONS_CATEGORY_OPTIONS: `${endpointBase}/content/questionsCategoryOptions/${locale}/`,
  QUESTIONS_DESCRIPTION_OPTIONS: `${endpointBase}/content/questionsDescriptionOptions/${locale}/`,
  QUESTIONS_PERSONALITY_OPTIONS: `${endpointBase}/content/questionsPersonalityOptions/${locale}/`,
  RESULT_RESPONSE: `${endpointBase}/content/resultResponses/${locale}/`,
};

export const getDatabaseData = url =>
  firebase
    .database()
    .ref(url)
    .once('value')
    .then(snapshot => snapshot.val());

export default firebase;



// WEBPACK FOOTER //
// ./src/api/index.js